module.exports = __webpack_public_path__ + "img/MessageIcon.b2985d62.svg";